import { getEndpoint, postData, } from './utils';
import * as config from './config';
export class Analytics {
    threshold = config.LOG_EVENT_THRESHOLD;
    pendingEvents = [];
    pendingRequest = Promise.resolve();
    reportingUrl;
    appId;
    deliveryInterval = null;
    constructor(options) {
        this.reportingUrl = getEndpoint(options.isProd);
        this.appId = options.appId;
        // Start the periodic delivery cycle
        this.deliveryInterval = setInterval(() => {
            this.scheduleDelivery();
        }, config.LOG_INTERVAL_MS);
        // Initial delivery
        this.scheduleDelivery();
    }
    destroy() {
        this.pendingEvents = [];
        this.pendingRequest = Promise.resolve();
        if (this.deliveryInterval) {
            clearInterval(this.deliveryInterval);
            this.deliveryInterval = null;
        }
    }
    scheduleDelivery() {
        // Only schedule delivery if we have events to send
        if (this.pendingEvents.length === 0) {
            return this.pendingRequest;
        }
        this.pendingRequest = this.pendingRequest
            .then(() => this.submitPendingEvents())
            .catch((error) => {
            console.error('Failed to submit events:', error);
            // Return resolved promise to continue the chain
            return Promise.resolve();
        });
        return this.pendingRequest;
    }
    submitPendingEvents() {
        const events = this.pendingEvents.splice(0);
        if (!events.length) {
            return Promise.resolve();
        }
        const payload = this.createPayload(events);
        return postData(this.reportingUrl, payload)
            .then(() => {
            this.threshold = config.LOG_EVENT_THRESHOLD;
        })
            .catch((error) => {
            this.pendingEvents.unshift(...events);
            this.threshold = Infinity;
            return Promise.reject(error);
        });
    }
    createPayload(events) {
        return {
            events,
            v: config.REPORTING_PROTOCOL_VERSION,
        };
    }
    /**
     * Adds an event to the pending queue for delivery
     */
    markEvent(eventData, timestamp = Date.now()) {
        const date = new Date(timestamp);
        this.pendingEvents.push({
            ...eventData,
            app_id: this.appId,
            timestamp_iso: date.toISOString(),
            timezone_offset: date.getTimezoneOffset(),
        });
        // Trigger delivery if threshold is reached
        if (this.pendingEvents.length >= this.threshold) {
            this.scheduleDelivery();
        }
    }
}
